// Global devtools toggle functions
declare global {
  interface Window {
    toggleRouterDevtools: () => void;
    toggleQueryDevtools: () => void;
    showDevtools: () => void;
    hideDevtools: () => void;
  }
}

export const devtoolsState = {
  routerVisible: false,
  queryVisible: false,
  setRouterVisible: (visible: boolean) => {
    devtoolsState.routerVisible = visible;
    window.dispatchEvent(
      new CustomEvent("devtools-router-toggle", { detail: visible }),
    );
  },
  setQueryVisible: (visible: boolean) => {
    devtoolsState.queryVisible = visible;
    window.dispatchEvent(
      new CustomEvent("devtools-query-toggle", { detail: visible }),
    );
  },
};

// Setup global functions
if (typeof window !== "undefined") {
  window.toggleRouterDevtools = () => {
    devtoolsState.setRouterVisible(!devtoolsState.routerVisible);
    console.log(
      `Router Devtools: ${devtoolsState.routerVisible ? "ON" : "OFF"}`,
    );
  };

  window.toggleQueryDevtools = () => {
    devtoolsState.setQueryVisible(!devtoolsState.queryVisible);
    console.log(`Query Devtools: ${devtoolsState.queryVisible ? "ON" : "OFF"}`);
  };

  window.showDevtools = () => {
    devtoolsState.setRouterVisible(true);
    devtoolsState.setQueryVisible(true);
    console.log("All Devtools: ON");
  };

  window.hideDevtools = () => {
    devtoolsState.setRouterVisible(false);
    devtoolsState.setQueryVisible(false);
    console.log("All Devtools: OFF");
  };
}
